import { colors } from '~/options/general';

const form = {
  color: colors.polarGreen,
};

export default { form };
